import * as React from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Stack,
  Divider,
  Button,
} from "@mui/material";
import moment from "moment";
import {
  CmpButton,
  CmpStatusIcon,
} from "../../../Component/Common/ToolBox/ToolBox";

export const WmsPhysicalStockCountSummaryTblCard = ({
  data = [],
  onClick = () => {},
  AssignBin = () => {},
}) => {
  return (
    <Grid container spacing={2} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
          <Paper
            elevation={4}
            onClick={() => onClick({ row: item })}
            sx={{
              p: 2,
              borderRadius: 3,
              transition: "all 0.2s ease",
              cursor: "pointer",
              "&:hover": {
                boxShadow: 6,
                transform: "scale(1.01)",
              },
            }}
          >
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Sheet #{item.A_SheetId}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "text.secondary",
                  backgroundColor: "grey.100",
                  px: 1,
                  py: 0.3,
                  borderRadius: 1,
                }}
              >
                {moment(item.A_Date).format("DD/MM/YYYY")}
              </Typography>
            </Box>

            {/* Divider */}
            <Divider sx={{ mb: 1 }} />

            {/* Info Grid */}
            <Grid container spacing={1.5}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="text.secondary"sx={{color:"blue"}}>
                  Location
                </Typography>
                <Typography variant="body1">{item.LocName}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2" color="text.secondary" sx={{color:"blue"}}> 
                  Ref No
                </Typography>
                <Typography variant="body1">{item.A_RefNo}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2" color="text.secondary" sx={{color:"blue"}}>
                  User
                </Typography>
                <Typography variant="body1">{item?.A_PDT_User_Name}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2" color="text.secondary" sx={{color:"blue"}}> 
                  Count Type
                </Typography>
                <Typography variant="body1">{item?.A_Count_Type}</Typography>
              </Grid>
            </Grid>

            {/* Status Icons */}
            <Divider sx={{ my: 1.5 }} />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Box textAlign="center">
                <Typography variant="caption" color="text.secondary">
                  Created
                </Typography>
                <CmpStatusIcon xStatus={item?.A_Created_Status} />
              </Box>

              <Box textAlign="center">
                <Typography variant="caption" color="text.secondary">
                  Assigned
                </Typography>
                <CmpStatusIcon xStatus={item?.BinAssignedStatus} />
              </Box>

              <Box textAlign="center">
                <Typography variant="caption" color="text.secondary">
                  Completed
                </Typography>
                <CmpStatusIcon xStatus={item?.A_Status} />
              </Box>
            </Stack>

            {/* Button Section */}
            <Box mt={2} display="flex" justifyContent="flex-end">
              <CmpButton
                xbtnName="Assign Bin"
                xOnClick={() => AssignBin({ row: item })}
                xVariant="contained"
                xSize="small"
              />
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};
